import Component from './UnitGrantDoorAccessDialogContainer'

export default Component
